module.exports = __webpack_public_path__ + "static/media/filter-brand.c23f7f17.svg";